import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Box } from "@mui/material";
const drawerWidth = 240;
export default function AdminLayout() {
    const [open, setOpen] = useState(true);
    return (
        <Box sx={{ display: "flex", minHeight: "98vh", background: '#FFFFFF' }}>
            <Sidebar open={open} setOpen={setOpen} drawerWidth={drawerWidth} />
            <Box sx={{ flexGrow: 1, width: `calc(100% - ${drawerWidth}px)`, display: "flex", flexDirection: "column", mt: 8 }}>
                <Header setOpen={setOpen} />
                <Box sx={{ flexGrow: 1, p: 3, background: "#f4f6f8", overflow: "auto" }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}